export default __webpack_public_path__ + "static/media/noCalls.490e6284.jpg";